import React, { useEffect, useState } from "react";
import { Card, Form } from '@themesberg/react-bootstrap';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row } from "react-bootstrap";
import { confirmArchiveDialog} from "../components/Alerts";
import clientApi from '../services/client-service';

const ClientPaymentTerms = (props) => {

    const { clientId, clientIncludeVat, refreshList, isEditMode } = props;

    const [includeVAT, setIncludeVAT] = useState(clientIncludeVat || false);

    const { setClientRateIncludeVat } = clientApi;

    const updateClientIncludeVat = (hasVat) => {
        let formData = new FormData();
    
        formData.append('clientId', clientId);
        formData.append('hasVat', hasVat);
    
        setClientRateIncludeVat(formData).then(() => {
          refreshList(clientId);
        });
    };

    const handleSetClientIncludeVat = async (e) => {
        const hasVat = e.target.checked;
        setIncludeVAT(hasVat);
        let eventMessage = "Deactivate";

        if(hasVat) eventMessage = "Activate"
        
        let text = `Do you want to ${eventMessage} this client to include VAT?`;
        let confirmBtnText = `Yes, ${eventMessage} it!`;
        let callbackTitle = !hasVat ? 'Deactivated!': 'Activated!';
        let callbackText = `Client rate include VAT has been ${!hasVat ? 'Deactivated!': 'Activated!'}`;
    
        var statusConfirm = await confirmArchiveDialog(text, confirmBtnText, callbackTitle, callbackText);
        if (statusConfirm) {
            updateClientIncludeVat(hasVat);
        }
    };

    useEffect(() => {
        setIncludeVAT(clientIncludeVat || false);
    }, [clientIncludeVat]);

    return (
        <Card border="light" className="shadow-sm mt-4">
            <Card.Body>
                <Row>
                    <Col md={10} className="mb-2">
                        <h5>VAT settings</h5>
                    </Col>
                </Row>
                <Row>
                    <Col md={12} className="mb-2">
                        <div className="d-flex align-items-center justify-content-between border-bottom border-light py-3">
                            <div>
                                <h6 className="mb-0">
                                    Client rate include VAT
                                </h6>
                            </div>
                            <div>
                                {isEditMode ? (
                                    <Form.Group id="client-rate-has-vat">
                                        <Form.Check
                                            checked={includeVAT}
                                            type="switch"
                                            name="client-rates-include-vat"
                                            id="client-rates-include-vat"
                                            htmlFor="client-rates-include-vat"
                                            onChange={(e) => handleSetClientIncludeVat(e)}
                                        />
                                    </Form.Group>
                                ) : (
                                    <>
                                        {includeVAT && (
                                            <h6 className="fw-normal text-gray">
                                                <FontAwesomeIcon icon={faCheckCircle} className="icon icon-xs text-success w-20 me-1 mt-2" />
                                            </h6>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default ClientPaymentTerms;